// @core/api/endpoints/audittrail/create_data_subject_access_request.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateDataSubjectAccessRequestRequest,
  DataSubjectAccessRequestResponse,
} from '../../../types/audittrail';

const BASE_PATH = '/audittrail';

/**
 * Create data subject access request
 * Creates a new data subject access request (DSAR) under GDPR or similar regulation. Automatically calculates the legal response deadline.
 */
export async function CreateDataSubjectAccessRequest(
  data: CreateDataSubjectAccessRequestRequest,
  options?: RequestOptions
): Promise<DataSubjectAccessRequestResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/audit/dsar`;
  const requestOptions = options;
  return client.post<DataSubjectAccessRequestResponse>(requestPath, data, requestOptions);
}
